var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"platform-compare"},[_c('div',{ref:"radarChart",staticClass:"chart-radar"}),_c('div',{ref:"barChart",staticClass:"chart-bar"})])
}
var staticRenderFns = []

export { render, staticRenderFns }